import { imagesUrl } from './resources.js';
import common from './common.js';
import store from '../store/index.js'

async function getImageByItem(itemId) {
    let restaurantName = store.state.restaurants.currentRestaurant.restaurantName;
    restaurantName = restaurantName.replace(/\s/g,'').toLowerCase();
    let url = `${imagesUrl}/getimageforitem/${restaurantName}/${itemId}`;
    let data = { image: [] };
    await common.getDataWithToken(url)
                .then(response => {
                    data.image = response });
    return data.image;
}

async function getImageUriByItem(itemId) {
    let restaurantName = store.state.restaurants.currentRestaurant.restaurantName;
    restaurantName = restaurantName.replace(/\s/g,'').toLowerCase();
    let url = `${imagesUrl}/getimageuriforitem/${restaurantName}/${itemId}`;
    let data = {};
    await common.getDataWithToken(url)
                .then(response => {
                    data = response });
    return data;
}

async function createImageForItem(itemId, image) {
    let containerName = store.state.restaurants.currentRestaurant.restaurantName;
    containerName = containerName.replace(/\s/g,'').toLowerCase();
    let url = `${imagesUrl}/uploadimageforitem/${containerName}/${itemId}`;
    return await common.postFile(url, image);
}

async function createImageForRestaurant(restaurantId, image) {
    let url = `${imagesUrl}/uploadimageforrestaurant/${restaurantId}`;
    return await common.postFile(url, image);
}

async function deleteImageForItem(itemId) {
    let containerName = store.state.restaurants.currentRestaurant.restaurantName;
    containerName = containerName.replace(/\s/g,'').toLowerCase();
    let url = `${imagesUrl}/deleteimageforitem/${containerName}/${itemId}`;
    return await common.deleteData(url);
}

async function deleteImageForRestaurant(restaurantId) {
    let url = `${imagesUrl}/deleteimageforrestaurant/${restaurantId}`;
    return await common.deleteData(url);
}

export default {
    name: 'itemsService',
    getImageByItem,
    getImageUriByItem,
    createImageForItem,
    createImageForRestaurant,
    deleteImageForItem,
    deleteImageForRestaurant
} 